import { render, staticRenderFns } from "./datto-configuration-wizard.vue?vue&type=template&id=37033b72&"
import script from "./datto-configuration-wizard.vue?vue&type=script&lang=ts&"
export * from "./datto-configuration-wizard.vue?vue&type=script&lang=ts&"
import style0 from "./datto-configuration-wizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports